import React from "react";
import { Modal, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { actions } from "../_redux/authRedux";

export default function TwoFactorBanner() {
  const dispatch = useDispatch();
  const show = useSelector(({ auth }) => auth.show2faBanner);

  const close = () => dispatch(actions.dismiss2faBanner());

  return (
    <Modal show={!!show} onHide={close} centered>
      <Modal.Header closeButton>
        <Modal.Title>Aktifkan Verifikasi Dua Langkah (2FA)</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Akun Anda belum menggunakan verifikasi dua langkah (2FA). Aktifkan
        2FA untuk melindungi akun Anda dari akses tidak sah, meskipun kata
        sandi Anda diketahui orang lain.
      </Modal.Body>
      <Modal.Footer>
        <Button variant="light" onClick={close}>
          Nanti saja
        </Button>
        <Button as={Link} to="/profile?tab=security" variant="warning" onClick={close}>
          Aktifkan 2FA sekarang
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
